/* Native image zoom, scoped to the currently visible Product Studio gallery. */
(() => {
  if (customElements.get('zoom-images')) return;
  customElements.define('zoom-images', class extends HTMLElement {
    connectedCallback() {
      this.mediaContainer = this.closest('[data-product-single-media-group]');
      if (!this.mediaContainer || this.onClick) return;
      this.onClick = event => {
        const wrapper = event.target.closest('[data-zoom-wrapper]');
        if (!wrapper || !this.mediaContainer.contains(wrapper)) return;
        event.preventDefault();
        const slider = this.mediaContainer.querySelector('[data-product-single-media-slider]');
        if (slider?.classList.contains('is-moving')) return;
        window.theme.a11y.state.trigger = wrapper;
        this.createZoom(wrapper);
      };
      this.mediaContainer.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.mediaContainer?.removeEventListener('click', this.onClick);
      this.onClick = null;
    }
    createZoom(selected) {
      const wrappers = [...this.mediaContainer.querySelectorAll('[data-zoom-wrapper]')]
        .filter(node => !node.closest('[data-product-studio-parked], [data-product-studio-hidden], [hidden]'));
      const index = wrappers.indexOf(selected);
      if (index < 0) return;
      const items = wrappers.map(node => ({
        src: node.getAttribute('href'), msrc: node.getAttribute('href'),
        w: parseInt(node.dataset.imageWidth, 10), h: parseInt(node.dataset.imageHeight, 10)
      }));
      const options = {
        barsSize: { top: 60, bottom: 60 }, history: false, focus: false, index,
        mainClass: 'pswp-zoom-gallery' + (items.length === 1 ? ' pswp-zoom-gallery--single' : ''),
        showHideOpacity: true, showAnimationDuration: 250, hideAnimationDuration: 250,
        closeOnScroll: false, closeOnVerticalDrag: false, captionEl: false, closeEl: true,
        closeElClasses: ['caption-close'], tapToClose: false, clickToCloseNonZoomable: false,
        maxSpreadZoom: 2, loop: true, spacing: 0, allowPanToNext: true, pinchToClose: false
      };
      new window.theme.LoadPhotoswipe(items, options);
    }
  });
})();
